import { makeVar } from '@apollo/client';
import { resetEmployeeInfoDialogVar } from '../../Employees/Employees.vars';
import { StepType } from './CreateDocumentDialog.types';

type FlatEmployeeRecordTag =
  import('../../../../businessComponents/EmployeeRecordTagsSelector/EmployeeRecordTagsSelector.helpers').FlatEmployeeRecordTag;
type Employee = {
  id: string;
  [key: string]: any;
};

export type CreateDocumentDialogVarType = {
  id?: number | null;
  open?: boolean;
  defaultEmployee?: Employee | null;
  categories?: { category: string; subcategory: string } | null;
  employeeRecordTag?: FlatEmployeeRecordTag[];
  onClose?: () => void;
  onCreateSuccess?: () => void;
};

const createDocumentDialogVarDefault: CreateDocumentDialogVarType = {
  id: null,
  open: false,
  defaultEmployee: null,
  categories: null,
  employeeRecordTag: [] as any[],
  onClose: () => {
    resetCreateDocumentDialogVar();
  },
  onCreateSuccess: () => {},
};

export const createDocumentDialogVar = makeVar(createDocumentDialogVarDefault);

export const resetCreateDocumentDialogVar = () => {
  createDocumentDialogVar(createDocumentDialogVarDefault);
};

export const setCreateDocumentDialogVar = (
  input: Partial<typeof createDocumentDialogVarDefault>,
) => {
  createDocumentDialogVar({
    ...createDocumentDialogVar(),
    ...input,
  });
};

export const createDocumentConterVar = makeVar<StepType>('EDITOR');

export const createDocumentSignersCounterVarDefault = {
  signers: 0,
  companySigners: 0,
};

export const createDocumentSignersCounterVar = makeVar(
  createDocumentSignersCounterVarDefault,
);

export const resetCreateDocumentSignersCounterVar = () => {
  createDocumentSignersCounterVar(createDocumentSignersCounterVarDefault);
};

export const setCreateDocumentSignersCounterVar = (
  input: Partial<typeof createDocumentSignersCounterVarDefault>,
) => {
  createDocumentSignersCounterVar({
    ...createDocumentSignersCounterVar(),
    ...input,
  });
};

export const globalTotalsVarDefault = {
  employees: 0,
  companySigners: 0,
};

export const globalTotalsVar = makeVar(globalTotalsVarDefault);

export const resetGlobalTotalsVar = () => {
  globalTotalsVar(globalTotalsVarDefault);
};

export const setGlobalTotalsVar = (
  input: Partial<typeof globalTotalsVarDefault>,
) => {
  globalTotalsVar({
    ...globalTotalsVar(),
    ...input,
  });
};

export const selectedEmployeeWithErrorVarDefault: any = {
  employee: null as { id: string } | null,
  errors: [],
  modifiedErrors: [],
};

export const selectedEmployeeWithErrorVar = makeVar(
  selectedEmployeeWithErrorVarDefault,
);

export const resetSelectedEmployeeWithErrorVar = () => {
  selectedEmployeeWithErrorVar(selectedEmployeeWithErrorVarDefault);
};

export const setSelectedEmployeeWithErrorVar = (
  input: Partial<typeof selectedEmployeeWithErrorVarDefault>,
) => {
  selectedEmployeeWithErrorVar({
    ...selectedEmployeeWithErrorVar(),
    ...input,
  });
};

export const createDocumentResetFilters = () => {
  resetCreateDocumentSignersCounterVar();
  resetGlobalTotalsVar();
  resetSelectedEmployeeWithErrorVar();
  resetEmployeeInfoDialogVar();
  resetCreateDocumentDialogVar();
  createDocumentConterVar('EDITOR');
};
